import { render, staticRenderFns } from "./FixMissingAllocations.vue?vue&type=template&id=b05eaa7a"
import script from "./FixMissingAllocations.vue?vue&type=script&lang=js"
export * from "./FixMissingAllocations.vue?vue&type=script&lang=js"
import style0 from "./FixMissingAllocations.vue?vue&type=style&index=0&id=b05eaa7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports